/**
 * Debug booking issue - Why does app work but test doesn't?
 * This file can be imported in App.js temporarily
 */

import { createBooking } from '../services/bookingService';
import { getCourseById } from '../services/courseService';

export async function debugBooking() {
  const COURSE_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
  
  console.log('🔍 DEBUGGING BOOKING ISSUE');
  console.log('=' .repeat(50));
  
  try {
    // 1. Get course and inspect status
    console.log('Fetching course...');
    const course = await getCourseById(COURSE_ID);
    console.log('Course response:', course);
    console.log('\n📚 COURSE DATA:');
    console.log('Title:', course.title);
    console.log('Status:', course.status);
    console.log('Status raw value:', JSON.stringify(course.status));
    console.log('Status length:', course.status?.length);
    
    // Check for hidden characters
    if (course.status) {
      const statusBytes = [];
      for (let i = 0; i < course.status.length; i++) {
        statusBytes.push(course.status.charCodeAt(i));
      }
      console.log('Status bytes:', statusBytes);
      console.log('Expected bytes for "published":', [112, 117, 98, 108, 105, 115, 104, 101, 100]);
      
      // Status checks
      console.log('\n🔍 STATUS CHECKS:');
      console.log('Equals "published"?', course.status === 'published');
      console.log('Equals "Published"?', course.status === 'Published');
      console.log('Equals "PUBLISHED"?', course.status === 'PUBLISHED');
      console.log('Trimmed equals "published"?', course.status.trim() === 'published');
      
      // Visual check
      console.log(`Visual: >"${course.status}"<`);
    }
    
    // 2. Test different booking styles
    console.log('\n🧪 TESTING BOOKINGS:');
    
    // Test A: Minimal booking (like test page)
    console.log('\nTest A: Minimal data (test page style)...');
    try {
      const minimalBooking = await createBooking({
        courseId: COURSE_ID,
        studentEmail: `test_${Date.now()}@test.com`,
        paymentType: { type: 'deposit' }
      });
      console.log('✅ MINIMAL BOOKING WORKED!', minimalBooking);
    } catch (err) {
      console.log('❌ Minimal booking failed:', err.message || err);
      if (err.response) {
        console.log('Response:', err.response);
      }
    }
    
    // Test B: App-style booking (like BookingWizard)
    console.log('\nTest B: Full data (app style)...');
    try {
      const fullBooking = await createBooking({
        courseId: COURSE_ID,
        amount: course.basePrice || 99900,
        paymentType: {
          id: 'standard',
          name: 'Standard Payment',
          type: 'full',
          amount: course.basePrice || 99900
        },
        status: 'slot_reserved',
        paymentStatus: 'pending',
        formStatus: 'not_started',
        studentEmail: null,
        createdAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 300000).toISOString()
      });
      console.log('✅ FULL BOOKING WORKED!', fullBooking);
    } catch (err) {
      console.log('❌ Full booking failed:', err.message || err);
    }
    
    // Test C: Just courseId
    console.log('\nTest C: Just courseId...');
    try {
      const bareBooking = await createBooking({
        courseId: COURSE_ID
      });
      console.log('✅ BARE BOOKING WORKED!', bareBooking);
    } catch (err) {
      console.log('❌ Bare booking failed:', err.message || err);
    }
    
  } catch (error) {
    console.error('Debug failed:', error);
  }
}

// Export for use
window.debugBooking = debugBooking;